<template>
    <div class="notice-detail-page">
        <!-- 顶部信息 -->
        <div class="page-header">
            <div class="header-info">
                <span class="info-item">
                    <span class="label">招标项目名称：</span>
                    <span class="value">{{ projectName }}</span>
                </span>
                <span class="divider"></span>
                <span class="info-item">
                    <span class="label">招标项目编号：</span>
                    <span class="value">{{ projectCode }}</span>
                </span>
            </div>
        </div>

        <!-- 表单 -->
        <div class="form-container">
            <div class="section-header">
                <span class="title">招标公告信息</span>
            </div>

            <el-form ref="formRef" :model="form" :rules="rules" label-width="150px" class="notice-form">
                <el-form-item label="原公告名称" v-if="mode === 'change'">
                    <el-input v-model="originalNoticeName" disabled placeholder="原公告名称" />
                </el-form-item>

                <el-form-item label="公告名称" prop="tenderNoticeName">
                    <el-input v-model="form.tenderNoticeName" placeholder="请输入公告名称" />
                </el-form-item>

                <el-form-item label="关联标段" prop="sections">
                    <el-checkbox-group v-model="selectedSectionCodes">
                        <el-checkbox
                            v-for="section in sectionList"
                            :key="section.bidSectionCode"
                            :label="section.bidSectionCode"
                            :disabled="mode === 'change'"
                        >
                            {{ section.bidSectionName }}
                        </el-checkbox>
                    </el-checkbox-group>
                </el-form-item>

                <el-form-item label="公告发布日期" prop="noticeSendTime">
                    <el-date-picker
                        v-model="form.noticeSendTime"
                        type="datetime"
                        placeholder="请选择公告发布日期"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                    />
                </el-form-item>

                <el-form-item label="文件获取开始时间" prop="biddingDocumentAcquisitionStartTime">
                    <el-date-picker
                        v-model="form.biddingDocumentAcquisitionStartTime"
                        type="datetime"
                        placeholder="请选择开始时间"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                    />
                </el-form-item>

                <el-form-item label="文件获取结束时间" prop="biddingDocumentAcquisitionEndTime">
                    <el-date-picker
                        v-model="form.biddingDocumentAcquisitionEndTime"
                        type="datetime"
                        placeholder="请选择结束时间"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                    />
                </el-form-item>

                <el-form-item label="投标截止时间" prop="bidDocumentSubmissionDeadline">
                    <el-date-picker
                        v-model="form.bidDocumentSubmissionDeadline"
                        type="datetime"
                        placeholder="请选择投标截止时间"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 100%"
                    />
                </el-form-item>

                <el-form-item label="公告正文" prop="noticeContent">
                    <RichTextEditor v-model="form.noticeContent" :height="300" placeholder="请输入公告正文..." toolbar-type="default" />
                </el-form-item>

                <el-form-item label="附件上传">
                    <div class="upload-area">
                        <el-button @click="handleUploadAttach">
                            <i class="el-icon-upload2"></i> 上传附件
                        </el-button>
                        <span class="upload-tip">支持pdf、word、excel格式，单个文件不超过50MB</span>
                    </div>
                    <div v-if="attachFileList && attachFileList.length > 0" class="attach-file-list">
                        <div v-for="(file, fIndex) in attachFileList" :key="fIndex" class="attach-file-item">
                            <span class="attach-file-name">{{ file.name }}</span>
                            <el-progress v-if="file.uploading" :percentage="file.progress"></el-progress>
                            <span v-if="file.uploaded && !file.uploading" class="attach-file-status">已上传</span>
                            <span v-if="!file.uploading && !file.uploaded && file.error" class="attach-file-error">上传失败</span>
                            <i class="el-icon-close attach-file-remove" @click="removeAttachFile(fIndex)"></i>
                        </div>
                    </div>
                </el-form-item>
            </el-form>

            <!-- 底部按钮 -->
            <div class="form-footer">
                <el-button @click="handleCancel">取消</el-button>
                <el-button type="info" @click="handleSave(0)" :loading="saveLoading">暂存</el-button>
                <el-button type="primary" @click="handleSave(1)" :loading="submitLoading">提交</el-button>
            </div>
        </div>

        <!-- 隐藏的文件上传input -->
        <input type="file" ref="attachFileInput" style="display: none" @change="handleAttachFileChange" accept=".pdf,.doc,.docx,.xls,.xlsx" />

        <!-- 支付二维码弹窗 -->
        <el-dialog
            title="扫码支付"
            :visible.sync="qrCodeDialogVisible"
            width="440px"
            center
            :close-on-click-modal="false"
            :append-to-body="true"
            @close="handlePaymentDialogClose"
        >
            <!-- 订单信息 -->
            <div class="order-info-section">
                <div class="order-info-row">
                    <span class="order-label">订单编号：</span>
                    <span class="order-value">{{ paymentOrderNumber }}</span>
                </div>
                <div class="order-info-row">
                    <span class="order-label">订单类型：</span>
                    <span class="order-value">{{ orderTypeText }}</span>
                </div>
                <div class="order-info-row">
                    <span class="order-label">支付金额：</span>
                    <span class="order-value order-amount">¥{{ orderDetail.orderPrice || '--' }}</span>
                </div>
            </div>

            <!-- 二维码 -->
            <div class="qr-code-container">
                <div ref="qrCodeRef" class="qr-code-box"></div>
                <p class="qr-code-tip">请使用微信或支付宝扫描二维码完成支付</p>
                <p class="qr-code-waiting">支付成功后系统将自动跳转公告列表页</p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handlePaymentDialogClose">取消支付</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Api_GetSemiProcessTenderNoticeDetail, Api_SaveSemiProcessTenderNotice,Api_CreateSemiProcessTenderNoticeOrder } from '@/api/modules/semiProcess'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { createSemiPlatformServiceOrderData, getSemiPlatformServiceOrderData, getOrderDetail } from '@/api/modules/pay'
import { getFileList } from '@/api/modules/base'
import QRCode from 'qrcodejs2'

export default {
    name: 'AgentPublishesNoticeEdit',

    components: {
        RichTextEditor
    },

    data() {
        return {
            mode: this.$route.query.mode,
            tenderNoticeCode: this.$route.query.tenderNoticeCode || '',
            originalNoticeCode: this.$route.query.originalNoticeCode || '',
            originalNoticeName: '',
            projectName: '',
            projectCode: '',
            sectionList: [],
            selectedSectionCodes: [],
            attachFileList: [],
            fileGuid: new Date().getTime() + Math.random().toString().substr(2, 5),
            saveLoading: false,
            submitLoading: false,
            // 支付二维码弹窗
            qrCodeDialogVisible: false,
            paymentOrderNumber: '',
            pollTimer: null,
            // 订单详情（弹窗内展示）
            orderDetail: {
                orderType: null,
                orderPrice: null
            },
            form: {
                noticeNature: Number(this.$route.query.noticeNature) || (this.$route.query.mode === 'change' ? 2 : 1),
                projectCode: this.$route.query.projectCode,
                tenderNoticeName: '',
                noticeSendTime: '',
                biddingDocumentAcquisitionStartTime: '',
                biddingDocumentAcquisitionEndTime: '',
                bidDocumentSubmissionDeadline: '',
                noticeContent: '',
                sections: []
            },
            rules: {
                tenderNoticeName: [
                    { required: true, message: '请输入公告名称', trigger: 'blur' }
                ],
                noticeSendTime: [
                    { required: true, message: '请选择公告开始时间', trigger: 'change' }
                ],
                biddingDocumentAcquisitionStartTime: [
                    { required: true, message: '请选择招标文件获取开始时间', trigger: 'change' }
                ],
                biddingDocumentAcquisitionEndTime: [
                    { required: true, message: '请选择招标文件获取结束时间', trigger: 'change' }
                ],
                bidDocumentSubmissionDeadline: [
                    { required: true, message: '请选择投标截止时间', trigger: 'change' }
                ]
            }
        }
    },

    computed: {
        orderTypeText() {
            const typeMap = {
                1: '平台服务费',
                2: '标书费',
                3: '半流程平台使用费'
            }
            return this.orderDetail.orderType != null
                ? (typeMap[this.orderDetail.orderType] || `类型${this.orderDetail.orderType}`)
                : '--'
        }
    },

    created() {
        this.projectName = this.$route.query.projectName || ''
        this.projectCode = this.$route.query.projectCode || ''
        this.getDetail()
    },

    beforeDestroy() {
        this.stopPollPaymentStatus()
    },

    methods: {
        getDetail() {
            let params = {
                projectCode: this.projectCode
            }
            // 变更公告场景：传入原公告编号获取原公告信息
            if (this.mode === 'change') {
                params.originalTenderNoticeCode = this.originalNoticeCode
            }
            if (this.mode !== 'add' && this.mode !== 'change') {
                params.tenderNoticeCode = this.$route.query.tenderNoticeCode
            }
            Api_GetSemiProcessTenderNoticeDetail(params).then(res => {
                if (res.code === 200 && res.data) {
                    const data = res.data
                    if (this.mode === 'change') {
                        // 变更公告：保存原公告名称用于展示，不覆盖表单字段
                        this.originalNoticeName = data.tenderNoticeName || ''
                    } else {
                        this.form.tenderNoticeName = data.tenderNoticeName || ''
                        this.form.noticeNature = data.noticeNature
                        this.form.noticeSendTime = data.noticeSendTime || ''
                        this.form.biddingDocumentAcquisitionStartTime = data.biddingDocumentAcquisitionStartTime || ''
                        this.form.biddingDocumentAcquisitionEndTime = data.biddingDocumentAcquisitionEndTime || ''
                        this.form.bidDocumentSubmissionDeadline = data.bidDocumentSubmissionDeadline || ''
                        this.form.noticeContent = data.noticeContent || ''
                        this.fileGuid = data.fileGuid || this.fileGuid
                        // 获取附件列表
                        if (data.fileGuid) {
                            this.getAttachFileList(data.fileGuid)
                        }
                    }
                    this.sectionList = data.sections || []
                    if (this.mode !== 'add') {
                        this.selectedSectionCodes = (data.sections || []).map(item => item.bidSectionCode)
                    }
                }
            }).catch(() => {
                this.$message.error('获取详情失败')
            })
        },

        handleCancel() {
            this.$router.back()
        },

        // 获取附件列表
        getAttachFileList(fileGuid) {
            getFileList(fileGuid).then(res => {
                if (res.code === 200 && res.data) {
                    this.attachFileList = (res.data || []).map(file => ({
                        name: file.fileName,
                        size: file.fileSize,
                        uploading: false,
                        uploaded: true,
                        progress: 100,
                        fileGuid: fileGuid,
                        uploadFileId: file.fileId,
                        filePath: file.fileUrl,
                        fileExtension: file.fileExtension
                    }))
                }
            }).catch(() => {
                this.attachFileList = []
            })
        },

        handleSave(status) {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    if (status === 1) {
                        this.submitLoading = true
                    } else {
                        this.saveLoading = true
                    }

                    // 构建sections数组
                    const selectedSections = this.sectionList
                        .filter(section => this.selectedSectionCodes.includes(section.bidSectionCode))
                        .map(section => ({
                            bidSectionCode: section.bidSectionCode,
                            bidSectionName: section.bidSectionName
                        }))

                    const submitData = {
                        ...this.form,
                        status: 0,
                        sections: selectedSections,
                        fileGuid: this.fileGuid,
                    }
                    // 如果已有tenderNoticeCode则传入（编辑模式或新增时首次提交返回的编码）
                    if (this.tenderNoticeCode) {
                        submitData.tenderNoticeCode = this.tenderNoticeCode
                    }
                    // 变更公告关联原公告
                    if (this.mode === 'change') {
                        submitData.originalNoticeCode = this.originalNoticeCode
                    }
                    // 变更公告传2，正常公告传1
                    submitData.noticeNature = this.mode === 'change' ? 2 : 1

                    Api_SaveSemiProcessTenderNotice(submitData).then(res => {
                        this.saveLoading = false
                        this.submitLoading = false
                        if (res.code === 200) {
                           // 保存后端返回的tenderNoticeCode，后续暂存/提交时传回避免重复新增
                           if (res.data && res.data.tenderNoticeCode) {
                               this.tenderNoticeCode = res.data.tenderNoticeCode
                           }
                           // 暂存：直接返回，不进入支付流程
                           if (status === 0) {
                               this.$message.success('暂存成功')
                               this.$router.push({ name: 'agentPublishesNotice', query: { projectCode: this.projectCode, projectName: this.projectName } })
                               return
                           }
                           // 变更公告不需要支付，直接提交返回
                           if (this.form.noticeNature == 2) {
                               this.$message.success('提交成功')
                               this.$router.push({ name: 'agentPublishesNotice', query: { projectCode: this.projectCode, projectName: this.projectName } })
                               return
                           }
                           // 正常公告提交：检查订单是否已缴费
                           this.checkOrderAndSubmit(this.tenderNoticeCode)
                        } else {
                            this.$message.error(res.msg || '保存失败')
                        }
                    }).catch(() => {
                        this.saveLoading = false
                        this.submitLoading = false
                    })
                }
            })
        },
        // 检查订单状态并提交：已缴费(paid=true)更新公告status=1，否则走支付流程
        checkOrderAndSubmit(tenderNoticeCode) {
            Api_CreateSemiProcessTenderNoticeOrder({
                tenderNoticeCode: tenderNoticeCode
            }).then(res => {
                if (res.code === 200 && res.data) {
                    // paid=true 说明已缴费，保存公告status=1后直接提交成功
                    if (res.data.paid === true) {
                        this.submitLoading = true
                        const submitData = { ...this.form, status: 1, sections: this.sectionList
                            .filter(s => this.selectedSectionCodes.includes(s.bidSectionCode))
                            .map(s => ({ bidSectionCode: s.bidSectionCode, bidSectionName: s.bidSectionName })),
                            fileGuid: this.fileGuid, tenderNoticeCode: tenderNoticeCode }
                        submitData.noticeNature = this.mode === 'change' ? 2 : 1
                        if (this.mode === 'change') {
                            submitData.originalNoticeCode = this.originalNoticeCode
                        }
                        Api_SaveSemiProcessTenderNotice(submitData).then(saveRes => {
                            this.submitLoading = false
                            if (saveRes.code === 200) {
                                this.$message.success('提交成功')
                                this.$router.push({ name: 'agentPublishesNotice', query: { projectCode: this.projectCode, projectName: this.projectName } })
                            } else {
                                this.$message.error(saveRes.msg || '提交失败')
                            }
                        }).catch(() => {
                            this.submitLoading = false
                            this.$message.error('提交失败')
                        })
                    } else {
                        this.createSemiPlatformServiceOrder(res.data.orderNumber)
                    }
                } else {
                    this.$message.error(res.msg || '创建订单失败')
                }
            }).catch(() => {
                this.$message.error('创建订单失败')
            })
        },
        // 创建订单信息、查询订单详情并生成支付二维码
        createSemiPlatformServiceOrder(orderNumber) {
            this.paymentOrderNumber = orderNumber
            // 先查询订单详情
            getOrderDetail({
                orderNumber: orderNumber
            }).then(detailRes => {
                if (detailRes.code === 200 && detailRes.data) {
                    this.orderDetail.orderType = detailRes.data.orderType != null ? detailRes.data.orderType : null
                    this.orderDetail.orderPrice = detailRes.data.orderPrice != null ? detailRes.data.orderPrice : null
                }
            }).catch(() => {
                // 查询订单详情失败不影响后续流程
            }).finally(() => {
                // 生成支付二维码
                createSemiPlatformServiceOrderData({
                    orderNumber: orderNumber
                }).then(res => {
                    if (res.code === 200 && res.data && res.data.payinfo) {
                        this.showQrCode(res.data.payinfo)
                        this.startPollPaymentStatus()
                    } else {
                        this.$message.error(res.msg || '生成支付二维码失败')
                    }
                }).catch(() => {
                    this.$message.error('生成支付二维码失败')
                })
            })
        },

        // 显示支付二维码
        showQrCode(payinfo) {
            this.qrCodeDialogVisible = true
            this.$nextTick(() => {
                if (this.$refs.qrCodeRef) {
                    this.$refs.qrCodeRef.innerHTML = ''
                }
                new QRCode(this.$refs.qrCodeRef, {
                    text: payinfo,
                    width: 200,
                    height: 200,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: QRCode.CorrectLevel.H
                })
            })
        },

        // 开始轮询支付状态
        startPollPaymentStatus() {
            this.stopPollPaymentStatus()
            this.pollTimer = setInterval(() => {
                getSemiPlatformServiceOrderData({
                    orderNumber: this.paymentOrderNumber
                }).then(res => {
                    if (res.code === 200 && res.data) {
                        if (res.data === true || res.data.orderStatus === 1) {
                            this.stopPollPaymentStatus()
                            this.qrCodeDialogVisible = false
                            this.$message.success('支付成功')
                            this.$router.push({ name: 'agentPublishesNotice' })
                        }
                    }
                }).catch(() => {
                    // 轮询失败不提示，避免频繁弹框
                })
            }, 3000)
        },

        // 停止轮询
        stopPollPaymentStatus() {
            if (this.pollTimer) {
                clearInterval(this.pollTimer)
                this.pollTimer = null
            }
        },

        // 关闭支付弹窗
        handlePaymentDialogClose() {
            this.stopPollPaymentStatus()
            this.qrCodeDialogVisible = false
            getSemiPlatformServiceOrderData({
                orderNumber: this.paymentOrderNumber
            }).then(res => {
                if (res.code === 200 && res.data) {
                    if (res.data === true || res.data.status === 1) {
                        this.$message.success('支付成功')
                        this.$router.push({ name: 'agentPublishesNotice' })
                    }
                }
            }).catch(() => {})
        },

        // 上传附件
        handleUploadAttach() {
            if (this.attachFileList.length >= 5) {
                this.$message.warning('最多只能上传5个附件')
                return
            }
            this.$refs.attachFileInput.click()
        },

        // 处理附件选择
        async handleAttachFileChange(event) {
            const files = Array.from(event.target.files)
            if (files.length === 0) return

            const file = files[0]
            if (!this.checkFileType(file.name)) {
                this.$message.error(`文件 ${file.name} 格式不正确！`)
                event.target.value = ''
                return
            }
            if (file.size / 1024 / 1024 > 50) {
                this.$message.error(`文件 ${file.name} 大小不能超过50MB！`)
                event.target.value = ''
                return
            }

            const fileItem = {
                name: file.name,
                size: file.size,
                uploading: true,
                uploaded: false,
                progress: 0,
                fileGuid: '',
                uploadFileId: '',
                filePath: '',
                error: false
            }
            this.attachFileList.push(fileItem)

            try {
                await doFileUpload(file, {
                    fileBindId: this.fileGuid,
                    onProgress: (percentage) => {
                        fileItem.progress = percentage
                    },
                    onSuccess: (res) => {
                        fileItem.uploading = false
                        fileItem.uploaded = true
                        fileItem.fileGuid = res.fileGuid
                        fileItem.uploadFileId = res.uploadFileId
                        fileItem.filePath = res.filePath
                        this.$message.success(`文件 ${file.name} 上传成功`)
                    },
                    onError: (error) => {
                        fileItem.uploading = false
                        fileItem.error = true
                        this.$message.error(`文件 ${file.name} 上传失败: ${error.message}`)
                    }
                })
            } catch (error) {
                fileItem.uploading = false
                fileItem.error = true
                this.$message.error(`文件 ${file.name} 上传失败`)
            }

            event.target.value = ''
        },

        // 检查文件类型
        checkFileType(fileName) {
            const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
            const allowedTypes = ['.pdf', '.doc', '.docx', '.xls', '.xlsx']
            return allowedTypes.includes(ext)
        },

        // 删除附件
        removeAttachFile(index) {
            this.attachFileList.splice(index, 1)
        }
    }
}
</script>

<style lang="less" scoped>
.notice-detail-page {
    background: #f5f5f5;
    min-height: 100vh;
    padding: 20px;
}

.page-header {
    background: #fff;
    padding: 16px 20px;
    margin-bottom: 12px;
}

.header-info {
    display: flex;
    align-items: center;
}

.info-item {
    font-size: 14px;
}

.label {
    color: #666;
}

.value {
    color: #333;
}

.divider {
    width: 1px;
    height: 14px;
    background: #ddd;
    margin: 0 20px;
}

.form-container {
    background: #fff;
    padding: 20px;
}

.section-header {
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
}

.title {
    font-size: 15px;
    font-weight: 500;
    color: #333;
}


.el-checkbox {
    margin-right: 16px;
}

.upload-area {
    display: flex;
    align-items: center;
    gap: 12px;
}

.upload-tip {
    font-size: 12px;
    color: #999;
}

.attach-file-list {
    margin-top: 12px;
}

.attach-file-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 0;
}

.attach-file-name {
    flex: 1;
    font-size: 13px;
    color: #333;
}

.attach-file-status {
    font-size: 12px;
    color: #67c23a;
}

.attach-file-error {
    font-size: 12px;
    color: #f56c6c;
}

.attach-file-remove {
    cursor: pointer;
    color: #999;
    &:hover {
        color: #f56c6c;
    }
}

.form-footer {
    padding-top: 24px;
    margin-top: 24px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: center;
    gap: 12px;
}

// 支付弹窗 - 订单信息
.order-info-section {
    background: #f7f8fa;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    padding: 14px 16px;
    margin-bottom: 16px;
}

.order-info-row {
    display: flex;
    align-items: center;
    padding: 6px 0;
    font-size: 14px;

    &:not(:last-child) {
        border-bottom: 1px dashed #e8e8e8;
    }
}

.order-label {
    color: #888;
    min-width: 80px;
    flex-shrink: 0;
}

.order-value {
    color: #333;
    word-break: break-all;
}

.order-amount {
    color: #e6a23c;
    font-weight: 700;
    font-size: 16px;
}

// 支付二维码弹窗样式
.qr-code-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 0;

    .qr-code-box {
        padding: 14px;
        background: #fff;
        border: 1px solid #eee;
        border-radius: 8px;
    }

    .qr-code-tip {
        margin-top: 15px;
        color: #666;
        font-size: 14px;
    }

    .qr-code-waiting {
        margin-top: 8px;
        color: #999;
        font-size: 12px;
    }
}

.dialog-footer {
    text-align: center;
}
</style>
